import { pipe } from 'fp-ts/function';
import { reduxForm } from 'redux-form';
import { connect, useSelector } from 'react-redux';
import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { ApplicationState, Option, CommanderThunkDispatch } from '@mews-commander/types';
import { presence, SelectField, StepperField, validation } from '@mews-commander/legacy-form';
import { ResponsiveTwoColumnsFormFields } from '@mews-commander/ui';
import { cut } from '../../actions';
import preferences from '../../../preferences';
import { FormValues } from './types';
import { getKeyCutterOptions } from './utils';

const {
    actions: { setPreferredKeyCutterId },
} = preferences;

interface FieldProps {
    reservationIds: string[];
    showKeyCutterCount?: boolean;
}
interface FormProps {
    onSuccess: () => void;
}

interface DispatchProps {
    onSubmit: (values: FormValues) => void;
}

export const constraints = {
    keyCount: { presence },
    keyCutter: { presence },
};

const keyCountProps = {
    label: <LocalizedText textKey={TextKey.KeyCount} />,
    name: 'keyCount',
    required: true,
};
const keyCutterProps = {
    label: <LocalizedText textKey={TextKey.KeyCutter} />,
    name: 'keyCutter',
    required: true,
};

export const KeyCutterFormFields = ({ showKeyCutterCount = false }: FieldProps) => {
    const keyCutterOptions: Array<Option> = useSelector(getKeyCutterOptions);
    return (
        <ResponsiveTwoColumnsFormFields>
            {showKeyCutterCount && <StepperField {...keyCountProps} min={0} />}
            <SelectField {...keyCutterProps} options={keyCutterOptions} />
        </ResponsiveTwoColumnsFormFields>
    );
};

export default pipe(
    KeyCutterFormFields,
    reduxForm({ validate: validation(constraints) }),
    connect<{}, DispatchProps, FieldProps & FormProps, ApplicationState>(
        null,
        (dispatch: CommanderThunkDispatch, { reservationIds, onSuccess }) => ({
            onSubmit: async ({ keyCutter, keyCount }) =>
                dispatch(cut(keyCutter, reservationIds, keyCount))
                    .then(() => dispatch(setPreferredKeyCutterId(keyCutter)))
                    .then(onSuccess),
        })
    )
);
